import { render, staticRenderFns } from "./SubscriptionMetadata.vue?vue&type=template&id=226a9784&scoped=true&"
import script from "./SubscriptionMetadata.vue?vue&type=script&lang=js&"
export * from "./SubscriptionMetadata.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionMetadata.vue?vue&type=style&index=0&id=226a9784&scoped=true&lang=scss&"
import style1 from "./SubscriptionMetadata.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226a9784",
  null
  
)

export default component.exports